import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flyout } from '@els/els-react--flyout';
import { LinkElement } from '@els/els-react--link-element';
import InnerHTML from '@Components/InnerHTML';
import { sanitizeDiscard } from '@Services/HtmlSanitizeService';

export default function SubstanceMetaItemComponent({ tooltip, content, link }) {
  const labelText = useMemo(() => sanitizeDiscard(tooltip, { allowedTags: [] }), [tooltip]);

  return (
    <Flyout
      className="substance__meta__item"
      flyout={<InnerHTML tag="span" html={tooltip} />}
      trigger="hover"
      placement="top-start"
      width="max-content"
      theme="simple"
      pointerType="primary"
      shouldCloseOnESC>
      {link && link.sourceUrl ? (
        <LinkElement data-e2e="substance-meta-item-link" className="substance__meta__item__content" href={link.sourceUrl} isExternal>
          <InnerHTML tag="span" html={content} />
        </LinkElement>
      ) : (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        <span className="substance__meta__item__content rx-focusable" tabIndex="0">
          <span className="u-els-hide-visually">{labelText}: </span>
          <InnerHTML tag="span" html={content} />
        </span>
      )}
    </Flyout>
  );
}

SubstanceMetaItemComponent.propTypes = {
  content: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  link: PropTypes.object,
};
